import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function VerticalViewIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path
        d="M5.41176 11.0588C5.02682 11.0588 4.69529 10.9198 4.41718 10.6416C4.13906 10.3635 4 10.032 4 9.64706V5.41176C4 5.02682 4.13906 4.69529 4.41718 4.41718C4.69529 4.13906 5.02682 4 5.41176 4H9.64706C10.032 4 10.3635 4.13906 10.6416 4.41718C10.9198 4.69529 11.0588 5.02682 11.0588 5.41176V9.64706C11.0588 10.032 10.9198 10.3635 10.6416 10.6416C10.3635 10.9198 10.032 11.0588 9.64706 11.0588H5.41176ZM5.41176 9.64706H9.64706V5.41176H5.41176V9.64706Z"
        fill="currentColor"
      />
      <path
        d="M5.41176 20.0001C5.02682 20.0001 4.69529 19.861 4.41718 19.5829C4.13906 19.3048 4 18.9733 4 18.5883V14.353C4 13.9681 4.13906 13.6366 4.41718 13.3585C4.69529 13.0803 5.02682 12.9413 5.41176 12.9413H9.64706C10.032 12.9413 10.3635 13.0803 10.6416 13.3585C10.9198 13.6366 11.0588 13.9681 11.0588 14.353V18.5883C11.0588 18.9733 10.9198 19.3048 10.6416 19.5829C10.3635 19.861 10.032 20.0001 9.64706 20.0001H5.41176ZM5.41176 18.5883H9.64706V14.353H5.41176V18.5883Z"
        fill="currentColor"
      />
      <path
        d="M19.3411 4.84706H14.0705C13.7067 4.84706 13.4117 5.14203 13.4117 5.50589C13.4117 5.86974 13.7067 6.16471 14.0705 6.16471H19.3411C19.705 6.16471 19.9999 5.86974 19.9999 5.50588C19.9999 5.14203 19.705 4.84706 19.3411 4.84706Z"
        fill="currentColor"
      />
      <path
        d="M19.3411 8.89441H14.0705C13.7067 8.89441 13.4117 9.18938 13.4117 9.55324C13.4117 9.91709 13.7067 10.2121 14.0705 10.2121H19.3411C19.705 10.2121 19.9999 9.91709 19.9999 9.55323C19.9999 9.18938 19.705 8.89441 19.3411 8.89441Z"
        fill="currentColor"
      />
      <path
        d="M19.3411 13.7883H14.0705C13.7067 13.7883 13.4117 14.0833 13.4117 14.4471C13.4117 14.811 13.7067 15.106 14.0705 15.106H19.3411C19.705 15.106 19.9999 14.811 19.9999 14.4471C19.9999 14.0833 19.705 13.7883 19.3411 13.7883Z"
        fill="currentColor"
      />
      <path
        d="M19.3411 17.8357H14.0705C13.7067 17.8357 13.4117 18.1307 13.4117 18.4945C13.4117 18.8584 13.7067 19.1534 14.0705 19.1534H19.3411C19.705 19.1534 19.9999 18.8584 19.9999 18.4945C19.9999 18.1307 19.705 17.8357 19.3411 17.8357Z"
        fill="currentColor"
      />
    </svg>
  );
}
